import { IAction } from '../sagas';
import { ADD_WALL_SUCCESS, UPDATE_WALL_SUCCESS, REMOVE_WALL_SUCCESS, REQUEST_WALL_SUCCESS, REQUEST_WALLS_SUCCESS, UPDATE_FEATUREDPOST_SUCCESS, UPDATE_FEATURED_ORDER_SUCCESS } from '../handlers.actions';

const initWallsStore: any = () => ([]);

/** WALLS REDUCER */
export const wallReducer = (state = initWallsStore(), action: IAction) => {
    switch (action.type) {
         case ADD_WALL_SUCCESS:
              return [
                   ...state.slice(0, action.payload),
                   action.payload,
                   ...state.slice(action.payload)
              ];
         case UPDATE_FEATURED_ORDER_SUCCESS:
         case UPDATE_WALL_SUCCESS:               
              return state.map((wall: any) => {
                   if (wall._id === action.payload._id) {
                        return action.payload;
                   }
                   return wall;
              });

         case REMOVE_WALL_SUCCESS:               
              return state.filter((wall: any) => wall._id !== action.payload);

         case REQUEST_WALL_SUCCESS:
              return [
                   ...state.slice(0, action.payload),
                   action.payload,
                   ...state.slice(action.payload)
              ];

         case REQUEST_WALLS_SUCCESS:
              return [ ...action.payload];
          
         case UPDATE_FEATUREDPOST_SUCCESS:
               return state.map((wall: any) => (wall._id === action.payload._id)? action.payload:wall);
         default:
              return state;
    }
};
